<template>
  
  <div class="d-flex align-center">
    <div
      v-for   = "(watcher, index) of watchers"
      :key    = "watcher"
      class   = "watcher"
      :style  = "{ 'z-index': watchers.length - index, 'margin-left': '-6px' }"
    >
      <Avatar 
        :user   = "watcher"
      >
      </Avatar>
    </div>
  </div>

</template>

<script>

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import Avatar from './Avatar';

// #endregion Imports

export default {

  // #region Properties

  computed: {
    ...mapState([
      'annotations',
      'user'
    ]),
    watchers() {
      if (!this.annotations.watchers) {
        return [];
      }

      // Make sure current user is first:
      const sortedWatchers = [
        this.user.name,
        ...this.annotations.watchers.filter(w => w !== this.user.name)
      ];

      return sortedWatchers;
    }
  },
  components: {
    Avatar
  }

  // #endregion Properties

}

</script>
